module.exports = __webpack_public_path__ + "static/media/classicidli.0d203a92.jpg";